import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";

export default function AuthLogin({ isHome }) {
  const { lang, proxy, socket, pages } = useSelector((state) => state);
  const [auth, setAuth] = useState({});
  const [rememberMe, setRememberMe] = useState(false);
  const [authError, setAuthError] = useState(null);

  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("ex");

  const md5 = require("md5");
  const [lable, setLable] = useState(false);
  const { register, handleSubmit, setValue } = useForm();
  useEffect(() => {
    const storedAccountString = localStorage.getItem("username");
    const storedPwdString = localStorage.getItem("password");
    const storedRememberMe = localStorage.getItem("remember_me") === "true";
    if (storedRememberMe && storedAccountString && storedPwdString) {
      setAuth({
        username: storedAccountString,
        password: storedPwdString,
      });
      setValue("username", storedAccountString);
      setValue("password", storedPwdString);
      setRememberMe(storedRememberMe);
    }
  }, []);

  const submit = (account) => {
    setLable(false);
    const hashedPassword = md5(auth.password || "");
    const requestBody = {
      account,
    };

    fetch(`${proxy()}/auth/login`, {
      method: "post",
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, content, data } = resp;
        const credential = data;
        // //console.log(resp)
        console.log("credential", credential);
        if (success) {
          if (rememberMe) {
            localStorage.setItem("username", account.username);
            localStorage.setItem("password", account.password);
            localStorage.setItem("remember_me", rememberMe);
          } else {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("remember_me");
          }
          localStorage.setItem("password_hash", hashedPassword);
          localStorage.setItem("_token", data.token);

          const stringifiedUser = JSON.stringify(data.data.username);
          localStorage.setItem("user", stringifiedUser);

          fetch(`${proxy()}/auth/activation/check`, {
            headers: {
              Authorization: data.token,
            },
          })
            .then((res) => res.json())
            .then((resp) => {
              const { success, data, activated, status, content } = resp;
              // //console.log(resp)
              if (!activated) {
                window.location.href = `/active`;
              }
              if (activated) {
                socket.emit("/dipe-production-user-login", {
                  username: auth.username,
                });
                if (isHome) {
                  window.location = `/${isHome}`;
                } else {
                  window.location = "/";
                }
              } else {
                if (
                  credential.data?.role === "pd" ||
                  credential.data?.role === "pm" ||
                  credential.data?.role === "ad" ||
                  credential.data?.role === "uad"
                ) {
                  window.location = "/active";
                } else {
                  window.location = "/diagram_db";
                }
              }
            });
        } else {
          // setAuthError(content);
          if (content === "Wrong customer account.") {
            setAuthError(lang["wrong account"]);
          } else if (content === "Một số trường có dữ liệu không hợp lệ") {
            setAuthError(lang["wrong info"]);
          } else if (content === "Tài khoản của bạn đã bị vô hiệu") {
            setAuthError(lang["account disabled"]);
          } else {
            setAuthError(content);
          }
        }
      });
  };
  return (
    <div classNameName="inner_page login">
      <div className="full_container">
        <div className="container">
          <div className="center verticle_center full_height">
            <div className="login_section">
              <div
                className="logo_login d-flex align-items-end justify-content-center"
                style={{ padding: "0px 0" }}
              >
                <div className="_logo">
                  <img
                    // width={150}
                    height={250}
                    src="images/logo/logoDPM_01.png"
                    alt="#"
                    style={{
                      width: "100%",
                      objectFit: "none",
                      // background: "#3c8e91",
                      background: "white",
                      // background: "#214162", //test2
                    }}
                  />
                </div>
                {/* <div
                  className="slogan"
                  style={{ textTransform: "uppercase", marginBottom: "30px" }}
                >
                  <div
                    className="t1"
                    style={{
                      fontSize: "16px",
                      lineHeight: "32px",
                      // color: "white",
                      color: "#23487d",
                      textTransform: "uppercase",
                    }}
                  >
                    tập đoàn dầu khí quốc gia Việt Nam
                  </div>
                  <div
                    className="t2"
                    style={{
                      fontSize: "20px",
                      lineHeight: "32px",
                      color: "#23487d",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      // color: "rgb(25 195 123)",
                    }}
                  >
                    tổng công ty <br />
                    phân bón và hóa chất dầu khí
                  </div>
                </div> */}
              </div>
              <div
                className="login_form"
                style={{
                  //DPM
                  background: "#44a1a1",
                }}
              >
                <form onSubmit={handleSubmit(submit)}>
                  <fieldset>
                    <div className="field">
                      <div class="row">
                        <div class="col-md-4"></div>
                        <div class="col-md-8" style={{ height: "25px" }}>
                          {authError && (
                            <span class="fw-bold error-message error-login">
                              {authError}
                            </span>
                          )}
                          {!authError && lable && myParam !== null && (
                            <span
                              style={{
                                fontSize: "14px",
                                fontFamily: "sans-serif",
                              }}
                              class="error-message error-login"
                            >
                              {lang["expired"]}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="field">
                      <div class="row">
                        <div class="col-md-4">
                          <label className="label_field text-white">
                            {lang["account"]}
                          </label>
                        </div>
                        <div class="col-md-8">
                          <input
                            className="form-control"
                            type="text"
                            {...register("username")}
                            placeholder={lang["account"]}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="field">
                      <label className="label_field text-white">
                        {lang["password"]}
                      </label>
                      <input
                        className="form-control"
                        type="password"
                        {...register("password")}
                        placeholder={lang["password"]}
                      />
                    </div>
                    {/* <div className="row mb-3">
                      <label className="label_field col-sm-3"></label>
                      <div className="col-sm-9">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="remember_me"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          <label
                            class="form-check-label text-white"
                            for="remember_me"
                          >
                            {lang["remember me"]}
                          </label>
                        </div>
                      </div>
                    </div> */}
                    <div className="field">
                      <label className="label_field hidden">hidden label</label>
                      <label className="form-check-label text-white">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="remember_me"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        {lang["remember me"]}
                      </label>
                    </div>
                    <div className="field margin_0">
                      <label className="label_field hidden">hidden label</label>
                      <button
                        type="submit"
                        className="main_bt"
                        style={{
                          // backgroundColor: "#379d9d",
                          // background: "rgb(33, 65, 98)",
                          // background: "#3c8e91",
                          //DPM
                          background: "white",
                          color: "#44a1a1",
                        }}
                      >
                        {lang["signin"]}
                      </button>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
